import { Reveal, SectionHead } from "./Reveal";
import { Briefcase, Globe2, Award, Gift } from "lucide-react";

const CHAPTERS = [
  {
    num: "01",
    icon: Briefcase,
    title: "Metro-city careers",
    body: "Every course lists the real salary bands our skills command in Delhi, Mumbai, Bengaluru and beyond — from ₹5 LPA entry roles to ₹18 LPA growth positions.",
    stat: "₹5 – 18 LPA",
    label: "Typical salary bands",
  },
  {
    num: "02",
    icon: Globe2,
    title: "Freelance income, globally",
    body: "Learn to win clients in India and overseas. Our graduates bill in dollars — from side income to full-time independent careers.",
    stat: "$1,200 – $7,000",
    label: "Monthly freelance potential",
  },
  {
    num: "03",
    icon: Award,
    title: "Certificates & diplomas",
    body: "Every program ends with a verifiable Sanvalio Academy certificate or diploma — proof of skill that employers and clients respect.",
    stat: "2 credentials",
    label: "Certificate & Diploma tracks",
  },
  {
    num: "04",
    icon: Gift,
    title: "Free freelancing mastery",
    body: "Every enrolled student gets our Freelancing Launchpad free of cost — pricing, proposals, client hunting and high-ticket closing included.",
    stat: "₹6,999 value",
    label: "Free with every enrollment",
  },
];

export const Outcomes = () => (
  <section id="outcomes" className="relative py-20 sm:py-28 lg:py-36 px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto" data-testid="outcomes-section">
    <SectionHead
      overline="The outcomes manifesto"
      title={<>No vague promises. <em className="text-gold-gradient not-italic">Numbers, on record.</em></>}
      sub="Before you enroll, know exactly what each skill pays — in jobs, in freelancing, and in the designations it unlocks."
    />
    <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
      {CHAPTERS.map((c, i) => (
        <Reveal key={c.num} delay={i * 0.08}>
          <article
            className="group relative h-full overflow-hidden rounded-2xl border border-white/10 bg-surface/70 p-8 sm:p-10 hover:border-gold/40 transition-colors duration-500"
            data-testid={`outcome-chapter-${c.num}`}
          >
            <span className="absolute -right-3 -top-6 font-display text-[7rem] leading-none text-white/[0.04] select-none">{c.num}</span>
            <c.icon size={22} className="text-gold" />
            <h3 className="mt-5 font-display text-2xl sm:text-3xl text-neutral-100">{c.title}</h3>
            <p className="mt-4 text-sm sm:text-base font-light leading-relaxed text-neutral-400">{c.body}</p>
            <div className="mt-7 border-t border-white/10 pt-5">
              <p className="font-display text-2xl text-champagne">{c.stat}</p>
              <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">{c.label}</p>
            </div>
          </article>
        </Reveal>
      ))}
    </div>
  </section>
);
